import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_7 = ({ skinColours, lipColours }) => {
  const colour0 = skinColours.shadow;
  const colour1 = lipColours.shadow;
  const colour2 = lipColours.shadow;
  const colour3 = '#40332E';
  const colour4 = '#FFFEF0';
  const colour5 = '#F2D5B2';
  const colour6 = '#FFE9CF';
  const colour7 = '#342723';

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M404.3,527.7l-9.3,2.8c5.4,5.3,12.5,11.1,15.5,11.8c3,0.7,27.4,3.5,27.4,3.5l-0.3-0.8
		C437.6,545,412.1,536.9,404.3,527.7z"
        />
        <path
          fill={colour1}
          d="M318.7,635.3c-3.3,0-28.4-11.1-28.4-11.1s-7.9-16.7,0.5-56.1c0,0,10.3-20.7,13.1-22.2
		c2.8-1.5,31.2-10.1,35.4-10.1c4.2,0,144.3,38.5,155.9,49.7c4.7,4.5,10.6,20,10.6,23.6c0,3.5-4.7,19.7-4.7,19.7s-12.8,13.9-27.2,9.9
		c-14.5-4-60.3-20.1-73.4-20.1C381.3,618.4,326.6,635.3,318.7,635.3z"
        />
        <path
          fill={colour2}
          d="M391.9,575c45.7,0,86,8.5,109.7,21.3c-2-4.5-4.4-8.8-6.5-10.9c-11.5-11.2-151.7-49.7-155.9-49.7
		c-4.2,0-32.6,8.6-35.4,10.1c-2.8,1.5-13.1,22.2-13.1,22.2c-2.1,10.1-3.2,18.6-3.6,25.8C311.2,582.4,349.2,575,391.9,575z"
        />
        <path
          fill={colour3}
          d="M322.6,629.5c-3.1,0-27-9.7-27-9.7s-7.5-14.6,0.4-49.2c0,0,9.7-18.2,12.4-19.5c2.7-1.3,29.7-8.9,33.7-8.9
		c4,0,140.1,34.9,151,44.7c4.4,4,7.1,16.4,7.1,19.5c0,3.1-4.4,17.3-4.4,17.3s-12,14.2-25.7,10.6c-13.7-3.5-59.8-18.2-72.2-18.2
		C379.7,616.2,330.1,629.5,322.6,629.5z"
        />
        <path
          fill={colour4}
          d="M312.9,621.2c0.9,0.8,8.8,3.4,14.1,2.4c18-3.1,68.5-17.1,80.8-14.1c11.4,2.8,64.5,21.3,69.8,18.6
		c5.3-2.7,22.4-18.8,8.9-38.4c-4.9-7.1-132.3-41.2-141.2-40.8c-8.9,0.4-28.2,2.8-30.2,4.4c-4,3.1-9.1,16.2-10.4,34.5
		C303.5,603,310.1,618.4,312.9,621.2z"
        />
        <path
          fill={colour5}
          d="M309.1,567.5c-0.4,6,7.1,13.3,12.8,15.1c5.8,1.8,20.4-6.2,55.8,3.3c0,0-23.1-4.7-46.5,2.7
		C317.5,592.9,300.2,583.7,309.1,567.5z"
        />
        <path
          fill={colour6}
          d="M480.9,621.9c-5.5,2.7-60.6-13.2-72.4-16.1c-12.8-3.1-65.2,8.4-83.9,11.5c-5.5,0.9-13.7-1.6-14.6-2.4
		c-0.4-0.4-0.9-1-1.4-1.9c1.6,4.1,3.2,7.1,4.3,8.2c0.9,0.8,8.8,3.4,14.1,2.4c18-3.1,68.5-17.1,80.8-14.1
		c11.4,2.8,64.5,21.3,69.8,18.6c2.8-1.4,8.9-6.6,12-14C486.5,618.2,482.9,620.9,480.9,621.9z"
        />
        <path
          fill={colour5}
          d="M312.6,566.8c2.1-1.6,21.8-4.4,30.8-5c9.1-0.6,140.2,30.9,145.3,37.9c0.3,0.5,1.2,4-4.7,6.5
		c1.7,1.9,6.6,1.8,8-0.9c-0.1-4.4-1.6-10.7-5.1-15.7c-4.9-7.1-132.8-41-141.7-40.6c-8.9,0.4-28.2,2.8-30.2,4.4
		c-3.7,2.9-8.5,14.6-10.1,31.2C307,575.2,310,568.9,312.6,566.8z"
        />
        <path
          fill={colour3}
          d="M310,621.1c-0.7-5.3,1.5-23,5.1-28.3c0,0,14.6,2,24.9-4.7c4.8-3.1,23-3.5,23-3.5c-23.5-2.8-38.4,5.8-45.5,1.5
		c-7.1-4.2-10.8-11.7-9.7-19.3c0,0-10,18.6-7.3,31C303.1,610.2,310,621.1,310,621.1z"
        />
        <path
          fill={colour3}
          d="M416.5,589.3c0,0,6.6,3.3,14.1,3C430.6,592.3,420.7,588.2,416.5,589.3z"
        />
        <path
          fill={colour3}
          d="M475.1,604.9c3.8,1.3,14.8,6,9.5,18.6c0,0,7.7-5.5,8.9-12.2c1.1-6.6,0-12.6-3.8-18.4
		C494.2,613.5,481.3,602.3,475.1,604.9z"
        />
        <path
          fill={colour3}
          d="M469.8,603.8c2.6,2.1-18.4-3.1-26.6-7C443.2,596.7,465.8,600.5,469.8,603.8z"
        />
        <polygon fill={colour5} points="449.4,583.4 447.9,593.2 451.9,583.9 	" />
        <polygon fill={colour3} points="337.3,587.1 339.6,602.7 340.9,586.8 	" />
        <polygon fill={colour3} points="407,610.5 405,604.1 402,609.7 	" />
        <polygon fill={colour3} points="431.2,568 432.7,574.4 436.2,569.2 	" />
        <polygon fill={colour5} points="379.7,562.5 378.6,579.2 382.2,563 	" />
        <polygon fill={colour4} points="350.7,568.4 346.8,554.9 346.5,569.9 	" />
        <path
          fill={colour0}
          d="M366.2,648c11.8-7.3,30.9-20.4,37.9-18.9c7,1.5,32,12.1,32,12.1l-6.5,5c0,0-24.7-12.5-32.7-11
		c-8,1.5-28.2,13-28.2,13L366.2,648z"
        />
        <path
          fill={colour7}
          d="M302.4,568.4c0,0-1.1,15.5,9.5,20.6c0,0-11.1,14.4-10.6,25.9c0,0-8.2-2.7-5.8-25.5
		C298,566.6,302.4,568.4,302.4,568.4z"
        />
        <path
          fill={colour7}
          d="M488.1,624.4c4.8-2.2,10.3-12.5,7.6-22.7c0,0-4.3,8-8.5,7.8C487.2,609.5,492.4,616.4,488.1,624.4z"
        />
      </g>
    </>
  );
};

export default Mouth_7;
